export const DURATION = [
    { label: '1 year', value: 1 },
    { label: '2 years', value: 2 },
    { label: '3 years', value: 3 },
    { label: '4 years', value: 4 },
    { label: '5 years', value: 5 },
    { label: '6 years', value: 6 },
    { label: '7 years', value: 7 },
    { label: '8 years', value: 8 },
    { label: '9 years', value: 9},
    { label: '10 years', value: 10},
    { label: '11 years', value: 11 },
    { label: '12 years', value: 12 },
   
];

export const NOTICE_PERIOD = [
    { label: '1 month', value: 1 },
    { label: '2 months', value: 2 },
    { label: '3 months', value: 3 },
    { label: '4 months', value: 4 },
    { label: '5 months', value: 5 },
    { label: '6 months', value: 6 },
    { label: '7 months', value: 7 },
    { label: '8 months', value: 8 },
    { label: '9 months', value: 9},
    { label: '10 months', value: 10},
    { label: '11 months', value: 11 },
    { label: '12 months', value: 12 },
   
];

export const RENEWAL_TERM = [
    { label: '1 month', value: 1 },
    { label: '2 months', value: 2 },
    { label: '3 months', value: 3 },
    { label: '4 months', value: 4 },
    { label: '5 months', value: 5 },
    { label: '6 months', value: 6 },
    { label: '7 months', value: 7 },
    { label: '8 months', value: 8 },
    { label: '9 months', value: 9},
    { label: '10 months', value: 10},
    { label: '11 months', value: 11 },
    { label: '12 months', value: 12 },
   
];

export const PAYMENT_TERM = [
    { label: '10 day', value: 10 },
    { label: '20 days', value: 20 },
    { label: '30 days', value: 30 },
    { label: '40 days', value: 40 },
    { label: '50 days', value: 50 },
    { label: '60 days', value: 60 },
    { label: '70 day', value: 70 },
    { label: '80 days', value: 80 },
    { label: '90 days', value: 90 },
    { label: '100 days', value: 100 },
    { label: '110 days', value: 110 },
    { label: '120 days', value: 120 },
];

export const COMMODITY = [
    { label: 'KD04 - Truckload Carrier', value: 1 },
    { label: 'Testing 1', value: 2 },
    { label: 'Testing 2', value: 3 },
    { label: 'Testing 3', value: 4 },
    { label: 'Testing 4', value: 5 },
    { label: 'Testing 5', value: 6 },
   
];

export const CURRENCY = [
    { label: 'Euro', value: 1 },
    { label: 'Dollar', value: 2 },
    { label: 'Testing 2', value: 3 },
    { label: 'Testing 3', value: 4 },
    { label: 'Testing 4', value: 5 },
    { label: 'Testing 5', value: 6 },
   
];

export const DISPLAY_AGREEMENT_COLUMNS = [
    {name:'Selected', label:"Selected", selected: false, ScreenColumnID: 0, ScreenID: 0, orderId:0},
    
    {name:"RateAgreementStatus", label:"Status",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:1},
    {name:"RateAgreementNumber", label:"Rate Agreement Number",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:2},
    {name:"BuyerEmail", label:"Buyer E-Mail",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:3},
    
    {name:"RevisionNumber", label:"Revision Number",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:4},
    {name:"EffectiveDate", label:"Effective Date",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:5},
    {name:"ExpiryDate", label:"Expiry Date",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:6},
    {name:"GSDB", label:"GSDB",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:7},
    {name:"Name", label:"Name",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:8},
    {name:"ContactName", label:"Contact Name",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:9},
    {name:"DescriptionofService", label:"Description of Service",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:10},
    {name:"FuelEscalator", label:"Fuel Escalator Flag",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:11},
    {name:"AutoExtensionFlag", label:"Auto Extension Flag",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:12},
    {name:"NoticePeriod", label:"Notice Period (Month)",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:13},
    {name:"RenewalTerm", label:"Renewal Term (Month)",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:14},
    {name:"ContractDuration", label:"Contract Duration",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:15},
    {name:"InitialContractEffectiveDate", label:"Initial Contract Effective Date",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:16},
    {name:"Alert", label:"Alert",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:17},
    {name:"SpecialTerms", label:"Special Terms",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:18},
    {name:"CreatedBy", label:"Created by",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:19},
    {name:"CreatedOn", label:"Created (Date/Time)",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:19},
    {name:"ModifiedOn", label:"Last Modified (Date/Time)",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:20},
    {name:"ModifiedBy", label:"Last Modified Name",selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:20},
    {name:'action', label:"action", selected: false, ScreenColumnID: 0, ScreenID: 0, orderId:0},
];

export const FILTER_COLUMN_LIST = ['agreementId','status', 'buyerEmail','revisionNo','effectiveDate','expiryDate' ,'gsdb','name', 'contactName','description',
'fuelEscalator','autoFlag','noticePeriod','renewal','duration', 'intialDate','alert','specialTerms','created','createdby', 'modifiedAt','modifiedBy' ]


